/**
 * IdentityFooter — anonymous "Guest" identity row pinned to the bottom of
 * the v3 history sidebar/drawer (T6/T8). No account exists yet (device-token
 * identity only), so there's no chevron/menu — this is a status row, not a
 * trigger. Purely presentational (no state/handlers) — stays a server
 * component.
 */
import { cn } from '@/lib/utils';
import { V3_COLORS } from '@/lib/design-tokens';
import { IdentityAvatar } from './primitives/identity-avatar';

/** Literal per spec (a slightly warmer/lighter tone than V3_COLORS.muted,
 *  which is used for body copy elsewhere — this subline is deliberately
 *  more muted still). */
const SUBLINE_COLOR = '#9a8f7f';

export interface IdentityFooterProps {
  className?: string;
}

export function IdentityFooter({ className }: IdentityFooterProps) {
  return (
    <div
      className={cn(
        'flex shrink-0 items-center gap-[12px] border-t px-3.5 py-[12px]',
        className
      )}
      style={{ borderColor: V3_COLORS.warmBorderAlt }}
    >
      <IdentityAvatar initials="G" size={36} />
      <div className="flex min-w-0 flex-col">
        <span
          className="truncate text-[14px] font-semibold"
          style={{ color: V3_COLORS.ink }}
        >
          Guest
        </span>
        <span className="truncate text-[12px]" style={{ color: SUBLINE_COLOR }}>
          Chats stay on this device
        </span>
      </div>
    </div>
  );
}
